import moment from 'moment';

export const calculateStartdate = (store, firstDate, parentList) => {
  var startdate = moment('9999-12-31');

  if (!parentList) {
    return startdate.format('YYYY-MM-DD');
  }

  for (var c of parentList) {
    var child;

    if (c.type === 'Stage') {
      child = { startdate: calculateStartdate(store, firstDate, c.children) };
    } else {
      child = store.state.parts[c._id];
    }

    if (child) {
      var childStartDate = moment(child.startdate);
      if (childStartDate.isBefore(startdate)) {
        startdate = childStartDate;
      }
    }
  }
  if (startdate.isSame('9999-12-31')) {
    startdate = moment(firstDate);
  }
  return startdate.format('YYYY-MM-DD');
};

export const calculateStartdateFromTree = (parent) => {
  var startdate = moment('9999-12-31');

  if (parent.startdate) {
    return parent.startdate;
  }

  if (parent.children) {
    for (var c of parent.children) {
      var childStartDate = calculateStartdateFromTree(c);

      childStartDate = moment(childStartDate);
      if (childStartDate.isBefore(startdate)) {
        startdate = childStartDate;
      }
    }
  }

  return startdate.format('YYYY-MM-DD');
};

export const calculateTime = (store, firstDate, parentList) => {
  var startdate = moment('9999-12-31');
  var enddate = moment('0000-01-01');

  for (var c of parentList) {
    var child;

    if (c.type === 'Stage') {
      child = {
        startdate: calculateStartdate(store, firstDate, c.children),
        calendarTime: calculateTime(store, firstDate, c.children),
      };
    } else {
      child = store.state.parts[c._id];
    }

    if (child) {
      var childEnddate = moment(child.startdate).add(child.calendarTime, 'days');
      var childStartDate = moment(child.startdate);

      if (childEnddate.isAfter(enddate)) {
        enddate = childEnddate;
      }

      if (childStartDate.isBefore(startdate)) {
        startdate = childStartDate;
      }
    }
  }
  if (startdate.isSame('9999-12-31')) {
    startdate = moment(firstDate);
    enddate = startdate;
  }

  var calendarTime = enddate.diff(startdate, 'days');
  return calendarTime;
};

export const calculateTotalWorkHours = (store, parentList) => {
  var hours = 0;
  if (!parentList) {
    return 0;
  }

  for (var c of parentList) {
    if (c.type === 'Stage') {
      hours += calculateTotalWorkHours(store, c.children);
    } else {
      var part = store.state.parts[c._id];
      if (part) {
        hours += parseInt(part.workHours);
      }
    }
  }

  return parseInt(hours);
};

export const getVisibleChildren = (store, parentList) => {
  var count = 0;

  for (var c of parentList) {
    if (c.type === 'Stage') {
      var stage = store.state.stages[c._id];
      if (stage && stage.showChildren === true) {
        count += getVisibleChildren(store, c.children);
      }
    }
    count++;
  }

  return parseInt(count);
};

export const findStage = (state, stageId) => {
  return state.stages[stageId];
};

export const generateTitleSuffix = (currentTitle) => {
  var words = currentTitle.split(' ');
  var lastWord = words.pop();

  var num = parseInt(lastWord);
  if (!isNaN(num)) {
    num++;
    return (words.join(' ') + ' ' + num).trim();
  }

  return (currentTitle + ' 2').trim();
};



// WEBPACK FOOTER //
// ./src/common/stageHelpers.js